import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toHref (e) {
    console.log('toHref')
    e.preventDefault()
    const href = e.currentTarget.dataset.href
    window.location.href = href
  }
}
